<template>
  <vx-card no-shadow>
  

 
    <div class="flex flex-wrap items-center justify-start">
  
      
    </div>
    <vs-table search :data="departments">


<template slot="header">
<vs-button @click="popupActive=true" color="primary" type="border"><i class="fa fa-plus"></i> Adicionar Departamento</vs-button>


            
          </template>
  <template slot="thead">
    <vs-th sort-key="name">Departamento</vs-th>
    <vs-th sort-key="responsible_name">Responsável</vs-th>
   <vs-th></vs-th>
  </template>

  <template slot-scope="{data}">
    <vs-tr :key="indextr" v-for="(tr, indextr) in data">

     

      <vs-td :data="data[indextr].name">
        {{ data[indextr].name }}
      </vs-td>
 <vs-td :data="data[indextr].responsible_name">
        <label for="" v-if="data[indextr].responsible_name"> {{ data[indextr].responsible_name }} </label>
        <label for="" v-else>Nenhum Responsavel</label>
      </vs-td>
<vs-td>
<div class="con-btns-user flex items-center justify-end">
                
                <div class="flex">
                  <vs-button type="border" size="small" icon-pack="feather" icon="icon-edit" class="mr-2" @click="openUpdate(tr)"></vs-button>
                  <vs-button type="border" size="small" icon-pack="feather" icon="icon-trash" color="danger" @click="deleteDepartment(tr)"></vs-button>
                </div>
              </div>
</vs-td>
    </vs-tr>
  </template>
</vs-table>
<div style="height: 50px;" id="div-with-loading" class="vs-con-loading__container"></div>
    <vs-popup class="holamundo" title="Actualizar departamento" :active.sync="popupUpdate">
      <!-- {{ department.user_id }} -->
          <label class="mt-8" for="">Departamento</label>
      <vs-input class="w-full mt-2 mb-5"  type="text"  v-model="department.name" />

    <label class="mt-10" for="">Responsável </label>
   
    <v-select class="mt-2" :options="employees"
                label="name"
                v-model="department.user_id"/>
<div class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-auto mt-2" @click="updateDepartment">Actualizar</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button>

      <div class="demo-alignment">


    
  </div>
    </div>
    </vs-popup>

       <vs-popup class="holamundo" title="Adicionar departamento" :active.sync="popupActive">
          <label class="mt-8" for="">Departamento</label>
      <vs-input class="w-full mt-2 mb-5"  type="text"  v-model="name" />

    <label class="mt-10" for="">Responsavel </label>
    <v-select class="mt-2" :options="employees"
                label="name"
                v-model="selectedEmployee"/>
                <!-- {{ selectedEmployee }} -->
<div class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-auto mt-2" @click="saveData">Salvar</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button>

      <div class="demo-alignment">


    
  </div>
    </div>
    </vs-popup>
  </vx-card>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'
import http from "../../../../http-common";

export default {
  components: {
    flatPickr,
    vSelect
  },
  data() {
    return {
        name:"",
        err:"",
        responsible_id:"",
departments:[],
employees:[],
selectedEmployee:"",
department:[],
 popupActive: false,
 popupUpdate: false,
  
    }
  },

 mounted() {
    this.initialize();
  },


  methods:{
      initialize() {
      this.getDepartments();
      this.getEmployees();
    
    },
    getEmployees() {
   
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
         params: {      status:1,
                       
                        paginate:1000
                    },
          
      };
      
      http
        .get("/employees/employees", config)
        .then((result) => {
          this.employees = result.data.Employees.data.reverse();
         
// alert("2")
        })
        .catch((error) => {
          error;
          
          if(error.response.status==401 ){
            this.$router.push('/').catch(() => {})
          }
         
        });
    },

    async saveData() {
      this.process = true;
       this.$vs.loading()
  
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
      const data = {
          name:this.name,
          responsible_id:this.selectedEmployee.user_id,
      };
      this.$validator.validateAll();
      await http
        .post("/companies/departments", data, config)
        .then((success) => {
          success;
          this.getDepartments();
        this.popupActive=false,
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Departamento salvo com sucesso",
            color: "success",
            position: "top-right",
          })
        })
   .catch((error) => {
          error;
          this.$vs.loading.close();
          if(error.response.status==422 ){
         this.err= error.response.data
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
          }else{
          this.$vs.notify({
            title: "Erro",
            text: "Aconteceu algum erro",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
          }
          
        });
    },
getDepartments() {
  this.$vs.loading({
        container: '#div-with-loading',
        scale: 1.0,
        type:'sound'
      })
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
      
      http
        .get("/companies/departments", config)
        .then((result) => {
          this.$vs.loading.close('#div-with-loading > .con-vs-loading')
          this.departments = result.data.Departments.reverse();

        })
        .catch((error) => {
          this.$vs.loading.close('#div-with-loading > .con-vs-loading')
          error;
         
        });
    },


        openUpdate(data){
         this.department=data
         this.department_id=this.department.id,
          this.popupUpdate=true;

          
        },

           async updateDepartment() {
       this.$vs.loading()

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
      const data = {
          name:this.department.name,
          responsible_id:this.department.user_id.user_id,
      };
      this.$validator.validateAll();
      await http
        .put(`/companies/departments/${this.department_id}`, data, config)
        .then((success) => {
          success;
          this.$vs.loading.close();
          this.getDepartments();
        this.popupUpdate=false,
         
          this.$vs.notify({
            title: "Sucesso",
            text: "Departamento salvo com sucesso",
            color: "success",
            position: "top-right",
          })
        })
   .catch((error) => {
          error;
          if(error.response.status==422 ){
         this.err= error.response.data
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
          }else{
          this.$vs.notify({
            title: "Erro",
            text: "Aconteceu algum erro",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
          }
          
        });
    },


      async deleteDepartment(data) {
        this.department = data;
        
    this.$vs.loading()
  
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
  
      

      await http
        .delete(`/companies/departments/${this.department.id}`, config)
        .then((success) => {
          success;
          this.$vs.loading.close()
       this.getDepartments()
          this.$vs.notify({
            title: "Sucesso",
            text: "Eliminado com sucesso",
            color: "success",
            position: "top-right",
          })
        })
    
        // this.$vs.loading.close('#div-with-loading > .con-vs-loading')
        .catch((error) => {
          error;
          this.err= error.response.data
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
        });
    },


  }

}
</script>
